export enum Colors {
  primaryColor = "22223B",
  bgColor = "F2E9E4",
  accent = "9F86C033",
  text = "4A4E69",
}
